/* src/app/shared/components/signature-pad/signature-pad.component.scss */
.signature-wrapper {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
}
.signature-canvas {
  width: 100%;
  height: 220px;
  display: block;
  touch-action: none;
  cursor: crosshair;
}
/*# sourceMappingURL=signature-pad.component-3X3WSBGT.css.map */
